import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const Pause: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props)}>
            <Path
                d="M13 4C11.3431 4 10 5.34315 10 7V32C10 33.6569 11.3431 35 13 35H15C16.6569 35 18 33.6569 18 32V7C18 5.34315 16.6569 4 15 4H13Z"
                fill={props.color}
            />
            <Path
                d="M25 4C23.3431 4 22 5.34315 22 7V32C22 33.6569 23.3431 35 25 35H27C28.6569 35 30 33.6569 30 32V7C30 5.34315 28.6569 4 27 4H25Z"
                fill={props.color}
            />
        </Svg>
    );
};

export default React.memo(Pause);
